module.exports = __webpack_public_path__ + "img/led_strip_r2.06758b32.png";